import { Chip, styled } from '@mui/material';

export const StyledLessonStatus = styled(Chip)({
	width: 'fit-content',
	height: '19px',
	'& .MuiChip-label': {
		fontSize: '14px',
		lineHeight: '28px',
		fontWeight: 400,
		paddingInline: '6px',
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
	},

	'& svg': {
		fontSize: '14px',
	},
});
